module.exports = __webpack_public_path__ + "static/media/One_Year_Saama.583f1fee.jpeg";